import { useEffect, useState } from 'react';
import { fetchAndProcess } from '../utils/data';
import { IProperty } from '../utils/types';
import YearAvailability from './YearAvailability';

import { Loader } from '@mantine/core';

const Availbility = () => {
  const params = new URLSearchParams(window.location.search);
  const propid = params.get('propid');

  const [loading, setLoading] = useState(true);
  const [property, setProperty] = useState<IProperty | null | undefined>(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (propid) {
          const processedProperty = await fetchAndProcess(propid);
          setProperty(processedProperty);
        } else {
          setProperty(undefined);
        }
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [propid]);

  if (loading) {
    return (
      <div className="availability-container">
        <div className="custom-loader-container">
          <div className="custom-loader">
            <Loader />
          </div>
        </div>
      </div>
    );
  }

  if (property === undefined || property === null) {
    return <div className="availability-container availability-404">404</div>;
  }

  return (
    <div className="availability-container">
      <YearAvailability property={property} />
    </div>
  );
};

export default Availbility;
